import React from 'react'
import { CssLayoutProperties } from '../utils/CssLayoutProperties'
import Button, { ButtonStyle } from './Button'
import { Icon } from './Icon'

interface ResponsiveIconButtonProps {
  label: string
  iconSrc: string
  iconSize?: number
  buttonStyle?: ButtonStyle
  onClick?: (() => void) | null
  disabled?: boolean
  flat?: boolean
  style?: CssLayoutProperties
  color?: string
  children?: React.ReactNode
}

export const ResponsiveIconButton: React.FC<ResponsiveIconButtonProps> = ({ iconSrc, children, label, iconSize, color, ...buttonProps }) => {

  return (
    <Button
      mobileRound
      {...buttonProps}
    >
      <Icon source={iconSrc} size={iconSize ?? 16} color={color ?? 'black'} />
      <span
        className="hideMobile"
        style={{ marginLeft: '10px' }}
      >
        {label}
      </span>
    </Button>
  )
}